import store from '@/store'

export const What = {
  ADMIN: 'ADMIN',
  BANKACCOUNT: 'BANKACCOUNT',
  CAUSE: 'CAUSE',
  ORGANIZATION: 'ORGANIZATION',
  PAYMENT: 'PAYMENT',
  RECURRING: 'RECURRING',
  USER_SECURITY: 'USER_SECURITY'
}

export const Verb = {
  ADMIN: 'ADMIN',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
  PUBLISH: 'PUBLISH'
}

function isAdmin() {
  let roles = store.state.users.profile.roles
  return (roles & 2) != 0
}

function isOwner(ownerId) {
  let userId = store.state.users.profile.id
  return userId == ownerId
}

const abilities = {
  ADMIN: {
    VIEW: (to) => {
      return isAdmin()
    }
  },
  BANKACCOUNT: {
    ADMIN: (to) => {
      return isAdmin()
    },
    EDIT: (to) => {
      return isAdmin() || isOwner(to.ownerId)
    }
  },
  CAUSE: {
    EDIT: (to) => {
      return isAdmin() || isOwner(to.ownerId)
    },
    PUBLISH: (to) => {
      return to.security == 'approved'
    }
  },
  ORGANIZATION: {
    EDIT: (to) => {
      return isAdmin() || isOwner(to.ownerId)
    }
  },
  PAYMENT: {
    ADMIN: (to) => {
      return isAdmin()
    },
    EDIT: (to) => {
      return isAdmin()
    }
  },
  RECURRING: {
    EDIT: (to) => {
      return isAdmin() || isOwner(to.ownerId)
    }
  },
  USER_SECURITY: {
    EDIT: (to) => {
      return isAdmin()
    }
  }
}

export function can(verb, what, to) {
  let functor = abilities[what][verb]
  let result = functor(to)
  // console.log(abilities, verb, what, to, result)
  return result
}

export default {
  What,
  Verb,
  can
}